import styled from "styled-components";


export const Box = styled.div`
    text-align: center;
    margin-top: 25vh;
`;